import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadStorageLocation = async () => {
    try {
        const payload = {

            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.PRODUCTION_STORAGE_LOCATION_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadSONumberList = async () => {
    try {
        const payload = {

            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.PRODUCTION_STORAGE_GET_SO_NUMBER_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadSONumberListWarehouse = async (payload) => {
    try {
       

        return await callApi(API_ENDPOINTS.PRODUCTION_STORAGE_GET_SO_NUMBER_LIST_WAREHOUSE, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadSONumberListReelTransfer = async (payload) => {
    try {
        // const payload = {

        //     p_companyid: localStorage.getItem('companyid') || 0,
        //     p_plantid: 1,
        // };

        return await callApi(API_ENDPOINTS.PRODUCTION_GET_SO_NUMBER_LIST_REEL_TRANSFER, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadSONumberWiseLineItemReelTransfer = async (payload) => {
    try {


        return await callApi(API_ENDPOINTS.PRODUCTION_GET_SO_NUMBER_WISE_LINE_ITEMS_REEL_TRANSFER, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadSONumberWiseChildRollList = async (payload) => {
    try {


        return await callApi(API_ENDPOINTS.PRODUCTION_GET_SO_NUMBER_WISE_CHILD_ROLL_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const reelTransferCRUD = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.PRODUCTION_GET_UPDATE_TRANSFER_REEL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
}

export const findTransferReelList = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.PRODUCTION_GET_TRANSFER_REEL_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
}